import React, { Component } from 'react';
import './SuperAdminSettingsPage.css';
import Page from '../../components/page/Page';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import mainAPI from '../../api/MainAPI';
import history from '../../history';
import PrimaryButton from '../../components/primaryButton/PrimaryButton';
import CreateNewDrugTypePopup from '../../popups/createNewDrugTypePopup/CreateNewDrugTypePopup';

export default class SuperAdminSettingsPage extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount = async () => {
		let user_groups = await mainAPI.user_group.allWithMetrics();
		this.setState({ user_groups});
	};

	_showCreateDrugTypePopup = () => {
		window.popupController.show(CreateNewDrugTypePopup, {
			title: 'Create new drug type',
			onComplete: async (newDrug) => {
				return mainAPI.drug_type.create(newDrug);
			}
		});
	};

	_createGroup = () => {
		history.navigate('/group/create');
	};

	_renderGroups = () => {
		let display = [];
		for (let i in this.state.user_groups) {
			let user_group = this.state.user_groups[i];
			display.push(
				<div tabIndex="0"
					className="row"
					onClick={() => {
						history.push('/group/users/' + user_group.id);
					}}
				>
          <Label black >{user_group.name}</Label>
					<Label red>{user_group.has_overdue_invoice ? 'Overdue Invoice' : ''}</Label>
          <Label red >{(user_group.negative_percent || 0).toFixed(1) + '%'}</Label>
          <Label green >{(user_group.positive_percent || 0).toFixed(1) + '%'}</Label>
				</div>
			);
		}
		return display;
	};

	render() {
		return (
			<Page className="g-super-admin-settings-page">
				<Card>
					<div className="top-row">
						<Label larger black>
							Agencies
						</Label>
						<div className="actions">
							<PrimaryButton className="create-group" onClick={this._createGroup} color="white" bg="blue">
								Create New Agency
							</PrimaryButton>
							<PrimaryButton
								className="create-drug-type"
								onClick={this._showCreateDrugTypePopup}
								color="white"
								bg="blue"
							>
								Create New Drug
							</PrimaryButton>
						</div>
					</div>
					{this._renderGroups()}
				</Card>
			</Page>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/superAdminSettingsPage/SuperAdminSettingsPage.jsx